import '../../../../../../components/skeletons/skeleton.css'

export function PlansCategoryListSkeleton({ showBuckets = true }: { showBuckets?: boolean }) {
  return (
    <div className="bg-white">
      <PlansCategoryListStickyBarSkeleton />
      <PlansCategoryCardSkeleton showDivider={false} showBuckets={showBuckets} fundCount={2} />
      <PlansCategoryCardSkeleton showDivider showBuckets={showBuckets} fundCount={1} />
    </div>
  )
}

export function PlansCategoryListStickyBarSkeleton() {
  return (
    <div className="sticky top-[-2px] z-10 flex items-center justify-between bg-white px-5 py-4 border-b border-[#E8EBEA]">
      <div className="skeleton h-[13px] w-[88px] rounded-[4px]" />
      <div className="skeleton h-[13px] w-[52px] rounded-[4px]" />
    </div>
  )
}

export function PlansCategoryCardSkeleton({
  showDivider,
  showBuckets,
  fundCount
}: {
  showDivider: boolean
  showBuckets: boolean
  fundCount: number
}) {
  return (
    <div>
      {showDivider ? <div className="h-4 shrink-0 bg-[#F0F4F7]" aria-hidden /> : null}
      <div className="bg-white">
        <div className="flex items-center justify-between px-5 pt-6 pb-6">
          <div className="skeleton h-[14px] w-[148px] rounded-[4px]" />
          <div className="skeleton h-[13px] w-[92px] rounded-[4px]" />
        </div>
        <div className="ml-[22px] h-px bg-[#F0F4F7]" />
        {showBuckets ? (
          <>
            <PlansCategoryBucketRowSkeleton />
            <div className="flex flex-col gap-5 pt-1 pb-5">
              {Array.from({ length: fundCount }).map((_, fundIndex) => (
                <PlansCategoryFundCardSkeleton
                  key={`plans-category-fund-skeleton-${fundIndex}`}
                  showBottomDivider={fundIndex < fundCount - 1}
                />
              ))}
            </div>
            <div className="ml-[69px] h-px bg-[#F0F4F7]" />
            <PlansCategoryBucketRowSkeleton />
          </>
        ) : (
          <div className="flex flex-col gap-5 py-5">
            {Array.from({ length: fundCount }).map((_, fundIndex) => (
              <PlansCategoryFundCardSkeleton
                key={`plans-category-fund-skeleton-${fundIndex}`}
                showBottomDivider={fundIndex < fundCount - 1}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export function PlansCategoryBucketRowSkeleton() {
  return (
    <div className="flex min-h-[52px] items-center gap-3 px-5 py-6">
      <div className="skeleton h-6 w-8 shrink-0 rounded-[10px]" />
      <div className="skeleton h-[14px] w-[72px] rounded-[4px]" />
    </div>
  )
}

export function PlansCategoryFundCardSkeleton({ showBottomDivider }: { showBottomDivider: boolean }) {
  return (
    <div className="flex items-start gap-3 pl-4">
      <div className="skeleton h-10 w-10 shrink-0 rounded-full" />
      <div className={`min-w-0 flex-1 pr-5 ${showBottomDivider ? 'border-b border-[#F0F4F7] pb-5' : ''}`}>
        <div className="skeleton h-[13px] w-[72%] rounded-[4px]" />
        <div className="skeleton mt-1.5 h-[12px] w-[40%] rounded-[4px]" />
        <div className="flex items-center gap-2.5 pt-3">
          <div className="skeleton h-[18px] w-[48px] rounded-[4px]" />
          <div className="skeleton h-[18px] w-[56px] rounded-[4px]" />
        </div>
        <div className="flex gap-3 pt-5">
          <div className="skeleton h-10 min-w-[106px] flex-1 rounded-[8px]" />
          <div className="skeleton h-10 min-w-[106px] flex-1 rounded-[8px]" />
        </div>
      </div>
    </div>
  )
}
